import { useSelector } from 'react-redux';
import Widget from '..';
import { examsSelectors } from '../../slices/exams/examsSlice';
import { useEffect, useState } from 'react';
import moment from 'moment';
import { buildStyles, CircularProgressbar } from 'react-circular-progressbar';
import { fetchFirstStudySession } from '../../services/studySession';
import { UserExam } from '../../types/User';
import { WIDGET_KEYS } from '../../types/Widgets';

interface DaysUntilExamProps {
  isDemo?: boolean;
  showDelete?: boolean;
}

const DaysUntilExam: React.FC<DaysUntilExamProps> = ({
  isDemo = false,
  showDelete = false,
}) => {
  const primaryExam = useSelector(examsSelectors.selectPrimaryExam);
  const [daysUntilExam, setDaysUntilExam] = useState(0);
  const [totalDays, setTotalDays] = useState(0);

  useEffect(() => {
    if (primaryExam && !isDemo) {
      getFirstStudySession(primaryExam);
      const daysUntilExam = moment(primaryExam.examDate).diff(moment(), 'days');
      if (daysUntilExam < 0) {
        setDaysUntilExam(0);
      } else {
        setDaysUntilExam(daysUntilExam);
      }
    }
    if (isDemo) {
      setDaysUntilExam(40);
      setTotalDays(64);
    }
  }, [primaryExam, isDemo]);

  const getFirstStudySession = async (exam: UserExam) => {
    const response = await fetchFirstStudySession(exam.id);
    if (response) {
      const tDays = moment(exam.examDate).diff(moment(response.date), 'days');
      setTotalDays(tDays);
    }
  };

  return (
    <Widget
      widgetKey={WIDGET_KEYS.DAYS_UNTIL_EXAM}
      name={'days-until-exam'}
      title="Days Until Exam"
      showDelete={showDelete}
    >
      <div className="days-until-exam">
        <div className="progress-container">
          <CircularProgressbar
            value={Math.round(((totalDays - daysUntilExam) / totalDays) * 100)}
            strokeWidth={7}
            styles={buildStyles({
              pathTransitionDuration: 1,
              pathColor: 'var(--type-heading)',
              textColor: 'var(--type-heading)',
              trailColor: 'var(--surface-tertiary)',
            })}
          />
          <div className="progress-text">
            <span>{daysUntilExam}</span>
          </div>
        </div>
        <div className="days-until-exam_text">
          <div className="days-until-exam_text_until">until</div>
          <div className="days-until-exam_text_name">
            {isDemo ? 'USMLE Step 1' : primaryExam?.name}
          </div>
          <div className="days-until-exam_text_date">
            {isDemo
              ? moment().add(40, 'days').format('MMMM D, YYYY')
              : moment(primaryExam?.examDate).format('MMMM D, YYYY')}
          </div>
        </div>
      </div>
    </Widget>
  );
};

export default DaysUntilExam;
